<template>
  <div class="wrap">
    <div class="wrap_top">
      <div class="wrap_top_f">
        <img src="@/assets/ico/A6107.png" alt="">
        <div class="wrap_title">
          <div class="wrap_title_name">DaFa</div>
          <div class="wrap_title_sub">518.com</div>
        </div>
      </div>
      <div class="wrap_top_right">
        <span @click="showLang">{{ lanText }}</span>
        <div class="wrap_top_right_kf" @click="serviceChange">
          <van-icon name="chat-o" />
          {{ $t('My.service') }}
        </div>
      </div>
    </div>
    <div class="banner_wrap">
      <Banner @itemClick="swiperClick" />
    </div>
    <div class="notice_wrap">
      <div class="notice">
        <van-notice-bar
          class="notice_bar"
          :text="noticeArr.join('，')"
          left-icon="volume-o"
          color="#961f1f"
          background="transparent"
          :scrollable="true"
        />
      </div>
    </div>
    <div class="list_grid">
      <div class="list_grid_item app_card" @click="itemClick('/new-recharge')">
        <img src="@/assets/new/goods/recharge.png" alt="">
        {{ $t('btn.recharge') }}
      </div>
      <div class="list_grid_item app_card" @click="itemClick('/new-withdraw')">
        <img src="@/assets/new/goods/withdraw.png" alt="">
        {{ $t('btn.withdraw') }}
      </div>
      <div class="list_grid_item app_card" @click="itemClick('/agent')">
        <img src="@/assets/new/goods/agent.png" alt="">
        {{ $t('代理') }}
      </div>
    </div>
    <div class="login">
      <div class="login_left">
        <div class="login_left_img" @click="avatarClick">
          <Avatar :src="userInfo.userimg" :defaultSrc="require('@/assets/Img/myImg/head.png')" size="50" />
        </div>
        <div class="userInfo">
          <div class="userInfo_left" v-if="userInfo.token">
            <div class="left_name">{{ userInfo.username }}</div>
            <div class="left_money">{{ $t('邀请') }}: {{ userInfo.id }}</div>
          </div>
          <div class="userInfo_left" v-else>
            <div class="left_money" @click="avatarClick">{{ $t('newAdd.noLoginUserName') }}</div>
          </div>
        </div>
      </div>
      <div class="login_right">
        <div class="muted">{{ $t('newAdd.blance') }}</div>
        <div class="money">{{ $money(userInfo.money || '0.00') }}</div>
        <div class="rate">1 USDT = {{ usdtCurrency?.rate || 1 }} INR</div>
      </div>
    </div>
    <div class="stats app_card">
      <div class="stats_item">
        <div class="_item_title">{{ $t('今日下注') }}</div>
        <div class="_item_money">{{ $money(userInfo?.today_bet_money || '0.00') }}</div>
      </div>
      <div class="stats_item">
        <div class="_item_title">{{ $t('今日派息') }}</div>
        <div class="_item_money">{{ $money(userInfo?.today_commission || '0.00') }}</div>
      </div>
    </div>
    <div class="games">
      <div class="games_list app_card" v-for="item, index in merchants" :key="index" @click="toGame(item)">
        <div class="games_list_head">
          <div class="games_list_head_left">
            <div class="head_img">
              <img :src="item.picture" alt="">
            </div>
            <div class="head_titles">
              <div class="_title">{{ item.title }}</div>
              <div class="_num">{{ item?.lastinfo?.expect }}</div>
            </div>
          </div>
          <div class="head_subtitle">{{ item.subtitle }}</div>
        </div>
        <div class="games_list_open">
          <template v-if="item?.lastinfo?.codes">
            <template v-if="item.type.indexOf('hl') > -1">
              <div class="ball_wraps">
                <div class="ball_img" v-for="val, num in item?.lastinfo?.codes" :key="num">
                  <img class="img" :src="require(`../../assets/icon/dice/${val}.png`)" alt="">
                </div>
              </div>
            </template>
            <template v-else>
              <div class="ball" v-for="(val, num) in item?.lastinfo?.codes" :key="num">
                {{ val }}
              </div>
            </template>
          </template>
          <template v-else>{{ $t('status.open') }}</template>
        </div>
        <div class="games_list_fot">
          <div class="_text">{{ $t('开奖结果面板') }}</div>
          <div class="more" @click="moreClick(item.type)">{{ $t('更多') }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="game">
      <div class="game_tab">
        <div class="tab_item active">
          <img src="@/assets/new/goods/hot.png" alt="">
          <div class="item_text">{{ $t('热门游戏') }}</div>
        </div>
      </div>
    </div>
    <div class="shop_wrap">
      <div class="merchants_wrap app_card">
        <div class="merchant_item" :class="gameActive == index ? 'merchant_item_active' : ''"
          v-for="(item, index) in gameList" :key="index" @click="toGames(index)">
          <div class="item_left">
            <div class="title">{{ item.title }}</div>
          </div>
          <img :src="item.picture" alt="" />
        </div>
      </div>
      <div class="game_list">
        <div class="grid_list app_card" v-for="item, index in hotMerchants" :key="index" @click="toGame(item)">
          <div class="list_img">
            <img :src="item.picture" alt="">
          </div>
          <div class="list_cont">
            <div class="_title">{{ item.title }}</div>
            <div class="_subtitle">{{ item.subtitle }}</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="hall">
      <HallMarquee class="marquee" :height="208" :num="merchants.length">
        <template v-slot="{ item }">
          <div class="item">
            <div class="left">
              <Avatar size="50" :src="merchants[item.num]?.picture"
                :defaultSrc="require('@tt/assets/defaultAvatar/A6405.png')" />
              <div class="info">
                <div class="info_game_name">{{ merchants[item.num]?.title }}</div>
                <div class="nick_name">
                  {{ item.name }}
                </div>
                <div class="info_money">{{ $money(item.money) }}</div>
              </div>
            </div>
            <div class="right" @click="toGame(merchants[item.num])">{{ $t('立即游戏') }}</div>
          </div>
        </template>
</HallMarquee>
</div> -->
    <!-- <div class="hall_bg">
      <img class="img" src="@/assets/home/home_bg.png" alt="" />
    </div> -->
    <van-dialog v-model="dialogShow" :showConfirmButton="false" close-on-click-overlay>
      <img style="width: 100%" :src="homeImg" />
      <div class="close">
        <van-icon class="icon" name="close" @click="dialogShow = false" />
      </div>
    </van-dialog>
    <!-- <Popup v-model="ruleIsShow">
      <img :src="require('@tt/assets/home/rule.jpg')" width="100vw" alt="">
    </Popup> -->

    <van-action-sheet v-model="show2" :actions="verConfig.lans || Lans" @close="onClose" @select="onSelect" />
    <van-overlay :show="overlayShow" @click="overlayShow = false" z-index="99">
      <div class="overlay">
        <div class="overlay_item" v-for="item, index in list" :key="index" @click.stop="item.callback">
          <img :src="isHide ? item.icon1 : item.icon" alt="" v-if="item.icon1">
          <img :src="item.icon" alt="" v-else>
          <span>{{ $t(item.title) }}</span>
        </div>
      </div>
    </van-overlay>
    <!-- <div class="service" @click="serviceChange(0)">
      <img src="@/assets/new/goods/kefu.png" alt="">
    </div> -->
  </div>
</template>

<script>
import Tabbar from "@/components/Tabbar";
import LoadingRE from "@/components/LoadingRE";
import VueClipboard from "vue-clipboard2";
import { Toast, Badge, ActionSheet } from "vant";
import Cookies from "js-cookie";
import { GET_CONFIG_INFO, UNREAD_NUM } from "@tt/api";
import { Swipe, SwipeItem, Collapse, CollapseItem, Cell, Icon, Popup, ImagePreview, Dialog, Overlay, NoticeBar } from "vant";
import dataDetail from "@/utils/dataDetail";
import verConfig from "@/utils/verConfig";
import { getToken } from "@/utils/tools";
import Banner from "@/components/banner.vue";
import { Avatar } from "@tt/components";
// import Avatar from "@/components/avatar";
import HallMarquee from "@/components/hallMarquee.vue";
import { HOME_IMG } from "@/api";
import { Lans, getLanguage } from "@/i18n";
import Navbar from "@/components/JNav";
import { mapGetters } from "vuex";
export default {
  components: {
    Popup,
    Tabbar,
    LoadingRE,
    VueClipboard,
    Toast,
    [ActionSheet.name]: ActionSheet,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Cell.name]: Cell,
    Banner,
    Avatar,
    HallMarquee,
    [Icon.name]: Icon,
    Badge,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    [Overlay.name]: Overlay,
    Navbar,
    [NoticeBar.name]: NoticeBar
  },
  data() {
    this.Lans = Lans;
    return {
      gameActive: 0,
      token: getToken(),
      langicon: "",
      langtext: "",
      language: "",
      dialogShow: false,
      homeImg: "",
      verConfig,
      islocalImg: true,
      // userInfo: {},
      country: Cookies.get("language"),
      bannerArr: [],
      noticeArr: [],
      inimenuArr: [{
        title: this.$t("newAdd.missionHall"),
        img: require("../../assets/icon/1.png"),
        activeImg: require("../../assets/icon/1-active.png"),
      },
      {
        title: this.$t("newAdd.helpCenter"),
        img: require("../../assets/icon/3.png"),
        activeImg: require("../../assets/icon/3-active.png"),
      },
      {
        title: this.$t("newAdd.inviteFriends"),
        img: require("../../assets/icon/7.png"),
        activeImg: require("../../assets/icon/7-active.png"),
      },
      ],
      menuArr: [],
      noticeArrss: [],
      menuVal: 0,
      allowed: 0,
      helpData: [],
      activeNames: 0,
      service_url: "",
      loadingNum: 0,
      noticeShowIndex: 3,
      unread: 0,
      ruleIsShow: false,
      show2: false,
      // merchants: [],
      timer: null,
      gameArr: [{
        icon: require('../../assets/new/goods/hzcp.png'),
        activeicon: require('../../assets/new/goods/hzcp_active.png'),
        width: '28px',
        height: '26px',
        title: "彩票",
      }, {
        icon: require('../../assets/new/goods/people.png'),
        activeicon: require('../../assets/new/goods/people_active.png'),
        width: '30px',
        height: '23px',
        title: "真人",
      }, {
        icon: require('../../assets/new/goods/football.png'),
        activeicon: require('../../assets/new/goods/football_active.png'),
        width: '25px',
        height: '25px',
        title: "体育",
      }, {
        icon: require('../../assets/new/goods/electronic.png'),
        activeicon: require('../../assets/new/goods/electronic_active.png'),
        width: '30px',
        height: '16px',
        title: "电子",
      }, {
        icon: require('../../assets/new/goods/esports.png'),
        activeicon: require('../../assets/new/goods/esports_active.png'),
        width: '24px',
        height: '23px',
        title: "电竞",
      }, {
        icon: require('../../assets/new/goods/qpyx.png'),
        activeicon: require('../../assets/new/goods/qpyx_active.png'),
        width: '29px',
        height: '25px',
        title: "棋牌",
      }, {
        icon: require('../../assets/new/goods/byyx.png'),
        activeicon: require('../../assets/new/goods/byyx_active.png'),
        width: '27px',
        height: '22px',
        title: "捕鱼",
      }],
      overlayShow: false,
      list: [{
        icon: require('@/assets/new/goods/deposit_.png'),
        callback: (() => { this.RechargeEvent(); this.overlayShow = false }),
        title: '订金'
      }, {
        icon: require('@/assets/new/goods/withdraw_.png'),
        callback: (() => { this.WithdrawEvent(); this.overlayShow = false }),
        title: 'newAdd.Withdraw'
      }, {
        icon: require('@/assets/new/goods/refresh.png'),
        callback: (() => { this.getUserInfo(); this.overlayShow = false }),
        title: '刷新余额'
      }, {
        icon: require('@/assets/new/goods/hide.png'),
        icon1: require('@/assets/new/goods/open.png'),
        callback: (() => {
          this.isHide = !this.isHide;
          this.overlayShow = false
        }),
        title: '隐藏余额'
      }, {
        icon: require('@/assets/new/goods/help.png'),
        callback: (() => { this.$router.push('/helpCenter'); this.overlayShow = false }),
        title: 'newAdd.helpCenter'
      }, {
        icon: require('@/assets/new/goods/logout.png'),
        callback: (() => { this.logoutEvent(); this.overlayShow = false }),
        title: 'My.logout'
      },],
      isHide: false,
      serviceList: [],
      serviceOpen: false,
      usdtCurrency: {},
      interval: null,
      getDataInterval: null,
      refreshingGameList: false
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    merchants() {
      return this.$store.getters.AllGameList;
    },
    gameList() {
      return this.$store.getters.GameCategoryList;
    },
    hotMerchants() {
      let _type = this.gameList[this.gameActive]?.types;
      return this.merchants && _type && this.merchants.filter(item => _type.includes(item.type))
    },
    lanText() {
      let _obj = Lans.find(item => item.value == getLanguage());
      return _obj?.name || '';
    }
  },
  methods: {
    avatarClick() {
      if (this.userInfo.token) { } else {
        this.$router.push('/login')
      }
    },
    async refreshGameList() {
      if (this.refreshingGameList) return;
      this.refreshingGameList = true;
      try {
        await this.$store.dispatch("getGameList", { type: 'all' });
      } finally {
        this.refreshingGameList = false;
      }
    },
    getMerchants(_data = []) {
      if (!Array.isArray(_data) || !_data.length) return;
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      let time = 0;
      const tick = () => {
        const data = this.$store.getters.AllGameList || [];
        const hasNoCode = data.some(item => !item?.lastinfo || !item.lastinfo.code);
        if (hasNoCode) {
          this.refreshGameList();
          return;
        }
        this.dataInit(data, time);
        time += 1;
      };
      tick();
      this.interval = setInterval(tick, 1000);
    },
    dataInit(data = [], time = 0) {
      if (!Array.isArray(data)) return [];
      const arr = [...data];
      for (let i = 0, len = arr.length; i < len; i++) {
        const item = data[i];
        if (!item) continue;
        const lastInfo = item.lastinfo || {};
        const currentInfo = item.currentinfo || {};
        if (!lastInfo.code) {
          item.countTime = this.$t("status.open");
          continue;
        }
        if (typeof currentInfo.countdown !== 'number') {
          item.countTime = this.$t("status.open");
          continue;
        }
        const remaining = currentInfo.countdown - time;
        if (remaining >= 0) {
          item.countTime = this.countFormat(remaining, item);
        } else {
          item.countTime = this.$t("status.open");
          if (!this.refreshingGameList) {
            this.refreshGameList();
          }
        }
      }
      return arr;
    },
    countFormat(num, data) {
      if (num <= 0) {
        if (data.currentinfo) {
          const { opentime, endtime } = data.currentinfo;
          if (this.getDataInterval) {
            clearTimeout(this.getDataInterval);
          }
          const delay = Math.max((opentime - endtime) * 1000, 1000);
          this.getDataInterval = setTimeout(() => {
            if (!this.refreshingGameList) {
              this.refreshGameList();
            }
          }, delay);
        }
        return this.$t("status.open");
      }
      const hourUnit = 60 * 60;
      const minuteUnit = 60;
      const secondUnit = 1;
      const targetH = Math.floor(num / hourUnit);
      const targetM = Math.floor((num % hourUnit) / minuteUnit);
      const targetS = Math.floor(((num % hourUnit) % minuteUnit) / secondUnit);
      return `${this.format(targetH)}:${this.format(targetM)}:${this.format(targetS)}`;
    },
    format(num) {
      return num >= 10 ? num : `0${num}`;
    },
    moreClick(type) {
      this.$router.push('/GameRecord?type=' + type)
    },
    itemClick(page) {
      this.$router.push(page)
    },
    noGameClick() {
      Toast(this.$t('维护中'))
    },
    goVip() {
      this.$router.push('/vip');
    },
    login() {
      this.$router.push("/login");
    },
    serviceChange(num) {
      // window.ssq.push('chatOpen');
      this.$store.dispatch('toService');
      // this.getHome(num)
    },
    checkIn() {
      this.$router.push('/CheckIn')
    },
    service(item) {
      if (item.paramet.url) {
        window.location.href = item.paramet.url;
      }
      // this.$apis.toService()
    },
    swiperClick(item, index) {
      if (item.action === 'goto_sale') {
        if(item.paramet && item.paramet.url){
          return this.$router.push(`/ActivityDetails?id=${item.paramet.url}`)
        }
        this.$router.push('/activity')
      } else if (item.action === 'web_system') {
        if (item.paramet && item.paramet.url) {
          window.location.href = item.paramet.url
        }
      } else if (item.action === 'lottery_room') {
        if (item.paramet && item.paramet.lottery_type) {
          this.toGame({ type: item.paramet.lottery_type })
        }
      } else if (item.action == 'open_agent') {
        this.$router.push('/agent')
      } else if (item.action == 'toast') {
        if (item.paramet && item.paramet.toast) {
          this.$toast(item.paramet.toast)
        }
      }
    },
    logoutEvent() {
      let _this = this;
      if (_this.userInfo.token) {
        Dialog.confirm({
          message: this.$t("My.logoutEvent"),
          cancelButtonText: this.$t("My.Button.One"),
          confirmButtonText: this.$t("My.Button.Two"),
        }).then(() => {
          let pwdState = _this.$cookie.get("the-pwd-state");
          let pwdObj = _this.$cookie.get("the-pwd-obj");
          _this.$cookie.clear();
          _this.$cookie.set("the-pwd-state", pwdState);
          _this.$cookie.set("the-pwd-obj", pwdObj);
          _this.$router.push("/login");
        }).catch(() => { });
      } else {
        this.$router.push("/login");
      }
    },
    gameClick(index) {
      if (index == this.gameActive) return;
      this.gameActive = index;
      if (index == 0) {
        this.$cookie.set('gameNum', index)
        return;
      }
      // Toast(this.$t('无法打开'))
    },
    async getHome(num) {
      Toast.loading()
      try {
        const { data } = await HOME_IMG();
        Toast.clear()
        if (data) {
          // if (data[num]) return window.location.href = data[num].paramet.url;
          // const find = data.find(item => item.paramet.url);
          // window.location.href = find.paramet.url;
        }
        // this.serviceList = data
        // this.serviceOpen = !this.serviceOpen
      } catch (error) {
        Toast.clear();
        // if(error.data.url) return window.location.href = error.data.url;
      }
    },
    showRule() {
      // this.ruleIsShow = true;
      ImagePreview([require("@tt/assets/home/rule.jpg")]);
    },
    showLang() {
      this.show2 = true;
    },
    onClose() {
      this.show2 = false;
    },
    onSelect(e) {
      this.$i18n.Locale = e.value;
      this.changeLanguage(e.value);
      Cookies.set("lang", e.value);
      this.language = e.value;
      this.show2 = false;
      this.langicon = e.icon;
      this.langtext = e.name;
    },
    async getUnread() {
      this.loadingNum++;
      try {
        const res = await UNREAD_NUM();
        res && (this.unread = res);
        this.loadingNum--;
      } catch (error) {
        this.loadingNum--;
      }
    },
    // add:点击充值的按钮
    RechargeEvent() {
      this.$router.push("/new-recharge");
    },
    // add 分享
    goshare() {
      this.$router.push("/inviteFriends");
    },
    // add:点击提现按钮
    WithdrawEvent() {
      this.$router.push({ name: "newWithdraw" });
    },
    // add:去下载
    downloadEvent() {
      if (localStorage.getItem("android")) {
        location.href = localStorage.getItem("android");
      } else {
        location.href = "http://www.baidu.com";
      }
    },
    // add/随机名字
    randName() {
      let name =
        String(dataDetail.rand(72, 99)) +
        dataDetail.rand(3, 9) +
        "****" +
        parseInt(Math.random() * 10) +
        parseInt(Math.random() * 10) +
        parseInt(Math.random() * 10);
      return name;
    },
    // add/随机
    randMoney() {
      let probability = dataDetail.rand(0, 100);
      if (probability <= 30) {
        return dataDetail.rand(100, 10000);
      } else {
        return dataDetail.rand(10000, 300000);
      }
    },
    // add:lunbo
    noticeIni() {
      for (let i = 0; i < 12; i++) {
        this.noticeArrss.push({
          name: this.randName(),
          money: this.randMoney(),
        });
      }
    },
    // add:lunbo
    noticeDataUpdate() {
      setInterval(() => {
        this.noticeArrss.splice(this.noticeShowIndex, 1, {
          name: this.randName(),
          money: this.randMoney(),
        });
        if (this.noticeShowIndex >= 4) {
          this.noticeShowIndex = 1;
        } else {
          this.noticeShowIndex++;
        }
      }, 3000);
    },
    toInvite() {
      this.$router.push({ name: "InviteFriends" });
    },
    toRecharge() {
      Dialog.alert({
        title: this.$t("My.MemberInformation.Recharge"),
        message: this.$t("hint.lxkf"),
        showCancelButton: true,
        confirmButtonText: this.$t("Login.goLoginText"),
        cancelButtonText: this.$t("newAdd.Cancel"),
      })
        .then(() => {
          this.$api.toService();
        })
        .catch(() => { });
      return;
      // this.$router.push({ name: "NewRecharge" });
    },
    toService() {
      this.$api.toService();
    },
    toWithdraw() {
      this.$router.push({ name: "newWithdraw" });
    },
    copySuccess() {
      // Toast('Copy success!')
      Toast(this.$t("newAdd.copySuccess"));
    },
    copyError() {
      // Toast('Copy the failure!')
      Toast(this.$t("newAdd.copyError"));
    },
    menuChange(val) {
      this.menuVal = val;
    },
    handleChange(val) { },
    // 获取用户信息
    getUserInfo() {
      this.loadingNum++;
      if (!this.userInfo.level) {
        this.$api.getUserInfo(
          (res) => {
            if (res.identity.indexOf("agent") == -1) {
              this.inimenuArr.splice(2, 1);
            }
            this.userInfo = res;
            this.loadingNum--;
            // Toast.clear()
          },
          (err) => {
            // Toast.clear()
            this.loadingNum--;
          }
        );
      }
    },
    toUnlock() {
      this.$router.push({ name: "levelUpgrade" });
    },
    getNotice() {
      this.$api.getNotice((res) => {
        this.usdtCurrency = res.currencys.find(item => item.code == 'usdt');
        this.noticeArr.push(res.scroll_notice);
        this.service_url = res.service_url;
        localStorage.setItem("android", res.appurl_android);
        localStorage.setItem("service_url", res.service_url);
      });
    },
    getBanner() {
      this.loadingNum++;
      this.$api.getBanner(
        (res) => {
          this.loadingNum--;
          if (res.length) {
            this.bannerArr = res;
            this.islocalImg = false;
          }
        },
        (err) => {
          this.loadingNum--;
        }
      );
    },
    // 获取分享地址
    getMenuArr() {
      this.loadingNum++;
      this.$api.getHomeConfig(
        (res) => {
          this.loadingNum--;
          this.menuArr = res.lists;
        },
        (err) => {
          this.loadingNum--;
        }
      );
    },
    getHelpArr() {
      this.loadingNum++;
      this.$api.getHomeHelp(
        (res) => {
          this.loadingNum--;
          for (let i = 0; i < res.lists.length; i++) {
            let res_item = res.lists[i];
            res_item.content = res_item.content.replace(/<[^>]*>/gi, "");
          }
          this.helpData = res.lists;
        },
        (err) => {
          this.loadingNum--;
        }
      );
    },
    // 获取商家(玩法)数据
    // async getMerchants() {
    //   try {
    //     const res = await $post("/lottery/setting");
    //     const { ret, msg, data } = res.data;
    //     this.merchants = data;
    //     this.$cookie.set("merchants", JSON.stringify(this.merchants));
    //   } catch (error) {}
    // },
    // 进入玩法
    toGame(item) {
      if (item.type.indexOf('qq') > -1) {
        return this.$router.push(`/Game_qq?type=${item.type}`)
      }
      this.$router.push(`/Game?type=${item.type}`);
    },
    toGames(index) {
      if (index == this.gameActive) return;
      this.gameActive = index;
      this.$cookie.set('gameNum', index)
      // if (index == 0) {
      //   return;
      // }
      // if (item.types[0].indexOf('qq') > -1) {
      //   return this.$router.push(`/Game_qq?type=${item.types[0]}`)
      // }
      // this.$router.push(`/Game?type=${item.types[0]}`);
    },
  },
  created() {
    // Toast.loading();
    // this.getUserInfo();

    this.$store.dispatch("getGameCategory");
    this.$store.dispatch("getuserInfo");
    this.$store.dispatch("getGameList", { type: 'all' })
    this.gameActive = this.$cookie.get('gameNum') || 0
    this.getNotice();
    // this.getBanner();
    // this.getMenuArr();
    // this.getHelpArr();
    // this.getUnread();
    // this.getHome();
    // this.$store.dispatch("getGameList");
    // this.getMerchants();
    // Lans.forEach((item) => {
    //   if (item.value == getLanguage()) {
    //     this.langicon = item.icon;
    //     this.langtext = item.name;
    //   }
    // });
  },
  mounted() {
    if (!this.$cookie.get("token")) {
      this.inimenuArr.splice(2, 1);
    }
    this.noticeIni();
    // this.noticeDataUpdate();
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
    clearInterval(this.interval);
    this.interval = null;
    if (this.getDataInterval) {
      clearTimeout(this.getDataInterval);
      this.getDataInterval = null;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    clearInterval(this.interval);
    this.interval = null;
    if (this.getDataInterval) {
      clearTimeout(this.getDataInterval);
      this.getDataInterval = null;
    }
  },
  watch: {
    merchants: {
      handler(newVal) {
        this.getMerchants(newVal);
      },
      immediate: true,
    },
    loadingNum: (newVal) => {
      // Toast.loading({
      //   forbidClick: true,
      //   duration: 0,
      // });
      if (!newVal) {
        setTimeout(() => {
          Toast.clear();
        }, 1000);
      }
      setTimeout(() => {
        Toast.clear();
      }, 10000);
    },
  },
};
</script>

<style lang="less" scoped>
@import url("../../assets/iconfonts/iconfont.css");
// @Color: #e23d6d;
@Color: var(--theme);
@comColor: var(--theme);
@wrapShadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
@wrapPadding: calc(12rem / 16);
@comRadius: 10px;
// @comBG: linear-gradient(#093958, #022c47);
@comBG: var(--bg1);

// 弹性布局
.flex(@JC: center; @FW: nowrap; @AI: center; @FD: row) {
  display: flex;
  flex-wrap: @FW;
  flex-direction: @FD;
  justify-content: @JC;
  align-items: @AI;
}

// 文字超出省略号
.text-overflow(@num: 1) {
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: @num;
}

.spancolor {
  color: @Color;
}

.service {
  position: fixed;
  right: calc(10rem / 16);
  bottom: calc(70rem / 16);
  z-index: 10;

  img {
    width: calc(44rem / 16);
    height: calc(44rem / 16);
    display: block;
    animation: moveUpDown .8s infinite alternate;
  }

  @keyframes moveUpDown {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(1.2);
    }
  }
}

.wrap {
  // background: #f5f5f5;
  padding: 10px 10px 18px;
  min-height: calc(100vh - 28px);
  overflow: hidden;
  background: radial-gradient(circle at top right, rgba(24, 179, 141, .12), transparent 26%), radial-gradient(circle at left 25%, rgba(47, 110, 246, .1), transparent 22%), linear-gradient(180deg, #f7f9fc, #eef2f7);

  .wrap_top {
    display: flex;
    gap: 12px;
    justify-content: space-between;

    .wrap_top_f {
      display: flex;
      gap: 12px;
      align-items: center;

      img {
        width: 72px;
        height: 72px;
        display: block;
        object-fit: contain;
        box-shadow: 0 16px 28px #5520001f;
        border-radius: 20px;
      }

      .wrap_title {
        color: #0f172a;
        line-height: 1;

        .wrap_title_name {
          font-size: 24px;
          font-weight: 900;
        }

        .wrap_title_sub {
          margin-top: 4px;
          font-size: 12px;
          letter-spacing: .12em;
        }
      }

    }

    .wrap_top_right {
      display: flex;
      align-items: center;
      gap: 8px;

      span {
        color: #667085;
        font-size: 13px;
        font-weight: 700;
      }

      .wrap_top_right_kf {
        border: 1px solid #18b38d2e;
        background: #18b38d14;
        color: #18b38d;
        padding: 0 8px;
        border-radius: 999px;
        font-size: 13px;
        height: 32px;
        line-height: 32px;
      }
    }
  }

  .banner_wrap {
    margin: calc(10rem / 16) 0;
    background: var(--main_bg);
    border-radius: 20px;
    overflow: hidden;
    // box-shadow: @wrapShadow;
  }

  .list_grid {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 10px;

    .list_grid_item {
      padding: 14px 18px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 6px;

      img {
        width: 22px;
        height: 22px;
      }

      font-size: 13px;
      font-weight: 700;
      color: #0f172a;
    }
  }

  .notice_wrap {
    padding: 0 @wrapPadding;
    background-color: #f6f6f6;
    border-radius: 16px;

    .notice {
      margin-top: calc(5rem / 16);
      display: flex;
      align-items: center;
      // padding: 0 calc(7.5rem / 16);
      height: 40px;
      line-height: 40px;

      .notice_bar {
        flex: 1;
        min-width: 0;
        height: 40px;
        padding: 0 !important;
        color: #0f172a;
        background: transparent !important;
        font-size: 14px;
      }

      /deep/ .van-notice-bar__wrap {
        height: 40px;
        line-height: 40px;
      }

      /deep/ .van-notice-bar__left-icon {
        margin-right: 8px;
        color: #0f172a;
      }
    }
  }

  .hall {
    margin: @wrapPadding;
    padding: @wrapPadding;
    // background: var(--moduleColor);
    border-radius: @comRadius;

    .title {
      color: var(--gold);
      margin-bottom: calc(5rem / 16);
    }

    .marquee {
      .item {
        padding: calc(10rem / 16) calc(15rem / 16);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          display: flex;
          font-size: calc(14rem / 16);

          .info {
            margin-left: calc(4rem / 16);
            padding: 1px 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: var(--light);
            font-size: calc(12rem / 16);
            gap: calc(10rem / 16);

            &_money {
              font-size: calc(15rem / 16);
            }
          }
        }

        .right {
          min-width: calc(70rem / 16);
          max-width: calc(110rem / 16);
          padding: 0 calc(5rem / 16);
          font-size: calc(12rem / 16);
          color: #df8c8c;
          border: 1px solid #df8c8c;
          border-radius: calc(50rem / 16);
          text-align: center;
          height: calc(30rem / 16);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      >div:nth-child(2n+1) {
        .item {
          background: linear-gradient(180deg, #ffe692, #ffd759 35.5%, #ffe58e 67.75%, #f79c17);

          .info {
            color: #961f1f;
          }

          .right {
            color: var(--light);
            background: linear-gradient(99.59deg, #470707 -4.56%, #9b0000 33.89%, #7e1414 74.63%, #470707 110.2%);
          }
        }
      }
    }
  }

  .hall_bg {
    margin: @wrapPadding;

    .img {
      width: 100%;
      display: block;
      height: calc(210rem / 16);
      border-radius: calc(10rem / 16);
    }
  }

  .login {
    padding: 14px 16px;
    display: flex;
    gap: 8px;
    margin-top: 10px;
    background: #ffffffe6;
    border-radius: 24px;
    box-shadow: 0 20px 40px rgba(15, 23, 42, .08);
    border: 1px solid rgba(15, 23, 42, .08);
    justify-content: space-between;

    .login_left {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 8px;
      justify-content: space-between;

      .login_left_img {
        width: 50px;
        height: 50px;
      }

      .userInfo {
        display: flex;
        flex: 1;

        .userInfo_left {
          display: flex;
          flex-direction: column;

          .left_name {
            color: #0f172a;
            font-size: 18px;
            font-weight: 800;
          }

          .left_money {
            font-size: calc(16rem / 16);
            color: #667085;
            margin-top: 2px;
          }
        }
      }
    }

    .login_right {
      text-align: right;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .muted {
        color: #667085;
      }

      .money {
        font-size: 16px;
        margin-top: 4px;
        font-weight: 900;
        color: #18b38d;
      }

      .rate {
        margin-top: 4px;
        font-size: 12px;
        color: #667085;
      }
    }
  }

  .stats {
    margin-top: 10px;
    display: grid;
    padding: 14px;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    .stats_item {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      ._item_title {
        color: #667085;
      }

      ._item_money {
        margin-top: 6px;
        font-size: 18px;
        font-weight: 600;
      }
    }
  }

  .games {
    display: grid;
    gap: 4px;
    margin-top: 10px;

    .games_list {
      padding: 14px;
      display: grid;
      gap: 16px;

      .games_list_head {
        display: flex;
        justify-content: space-between;

        .games_list_head_left {
          display: flex;
          gap: 10px;

          .head_img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              display: block;
            }
          }

          .head_titles {
            ._title {
              line-height: 1;
              font-weight: 600;
              font-size: 18px;
              color: #0f172a;
            }

            ._num {
              margin-top: 8px;
              color: #7a8597;
              font-size: 15px;
            }
          }
        }

        .head_subtitle {
          font-size: 12px;
          background: #31e2a5;
          padding: 2px 5px;
          height: fit-content;
          color: #fff;
          border-radius: 100px;
        }
      }

      .games_list_open {
        .ball {
          border-radius: 50%;
          width: calc(40rem / 16);
          line-height: calc(40rem / 16);
          margin: 1px;
          text-align: center;
          background: var(--theme);
          color: #000;
          display: inline-block;
          background-image: url("../../assets/icon/game_ball.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }

        .ball_wraps {
          display: flex;
          align-items: center;
          gap: calc(8rem / 16);

          .ball_img {
            box-shadow: 0 20px 40px rgba(15, 23, 42, .08);

            .img {
              width: calc(40rem / 16);
              height: calc(40rem / 16);
              display: block;
            }
          }
        }
      }

      .games_list_fot {
        display: flex;
        align-content: center;
        justify-content: space-between;
        font-weight: 600;

        ._text {
          color: #7a8597;
          font-size: 14px;
        }

        .more {
          color: #31e2a5;
          font-size: 14px;
        }
      }
    }
  }

  .game {
    background: #f6f6f6;
    padding: 0 calc(12rem / 16);
    margin-top: 10px;
    border-radius: 24px;

    .game_tab {
      display: flex;

      .tab_item {
        display: flex;
        align-items: center;
        padding: 10px 0;

        img {
          width: 19px;
          display: block;
        }

        .item_text {
          color: var(--theme);
          font-size: 18px;
        }
      }
    }

    // .game_wrap {
    //   display: flex;
    //   overflow-x: auto;
    //   column-gap: calc(12rem / 16);
    //   scrollbar-width: none;
    //   -ms-overflow-style: none;

    //   .game_item {
    //     position: relative;
    //     font-weight: bold;
    //     flex-shrink: 0;
    //     width: calc(77rem / 16);
    //     // height: calc(55rem / 16);
    //     overflow: hidden;
    //     text-align: center;
    //     background: linear-gradient(1turn, #470707 .03%, #953535 99.97%);
    //     border: 1px solid #470707;
    //     border-radius: calc(5rem / 16);
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    //     flex-direction: column;
    //     padding: calc(10rem / 16) 0;

    //     img {
    //       width: calc(30rem / 16);
    //       height: calc(30rem / 16);
    //       display: block;
    //     }

    //     color: #df8c8c;
    //     font-size: calc(12rem / 16);

    //     .title {
    //       margin-top: calc(3rem / 16);
    //     }
    //   }

    //   .item_active {
    //     background: linear-gradient(180deg, #ffe692, #ffd759 35.5%, #ffe58e 67.75%, #f79c17);
    //     color: #961f1f;
    //   }
    // }
  }

  .btns_wrap {
    margin: @wrapPadding;
    display: flex;
    // justify-content: space-between;
    // @itemGap: calc(10rem / 16);
    @itemGap: @wrapPadding;
    // box-shadow: @wrapShadow;

    .btn_item {
      padding: calc(6rem / 16) 0;
      // background: #002c47;
      // background: linear-gradient(#093a58, #002c47);
      background: var(--moduleColor);
      // color: @comColor;
      color: var(--gold);
      font-size: calc(12rem / 16);
      text-align: center;
      width: calc((100vw - @wrapPadding * 2 - @itemGap * 2) / 3);
      margin-left: @itemGap;
      border-radius: 6px;
      // box-shadow: @wrapShadow;

      &:nth-of-type(1) {
        margin-left: 0;
      }

      >i {
        font-size: calc(32rem / 16);
        color: #00bbfe;
      }

      img {
        height: calc(32rem / 16);
        color: #00bbfe;
      }

      .text {
        margin-top: calc(10rem / 16);
      }

      /deep/ .van-badge--fixed {
        top: calc(6rem / 16);
        right: calc(5rem / 16);
      }
    }
  }

  .all_game {
    margin: @wrapPadding;
    border-radius: @comRadius;
    overflow: hidden;

    /deep/ .van-cell {
      background: #063451;

      .van-cell__title {
        color: #00bbfe;
      }

      .van-cell__value {
        color: #8ba6c1;
      }

      .van-cell__right-icon {
        color: #8ba6c1;
      }
    }
  }

  .shop_wrap {
    margin: @wrapPadding;
    @radius: @comRadius;
    border-radius: @radius;
    gap: 15px;


    .merchants_wrap {
      display: flex;
      gap: 8px;
      background: #f8faff;
      border-radius: 24px;
      padding: 10px 8px;
      overflow-x: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      .merchant_item {
        border-radius: 8px;
        text-align: center;
        background-size: 100% 100%;
        justify-content: space-between;
        align-items: center;
        min-width: 84px;
        height: calc(140rem / 16);
        overflow: hidden;
        box-shadow: 0 2px 4px 0 hsla(0, 0%, 71.4%, .66);
        display: inline-block;
        padding: 10px 8px;

        .item_left {
          .title {
            font-size: 18px;
            text-align: left;
            margin-top: calc(8rem / 16);
            color: var(--theme);
          }

        }

        img {
          height: 100%;
        }
      }

      .merchant_item_active {
        .item_left {
          .title {
            color: #31e2a5;
          }
        }
      }

      .hl {
        display: unset;

        img {
          height: 100%;
          margin-top: 20px;
          // margin-right: -35px;
          // margin-bottom: -10px;
        }
      }

      .qq {
        display: flex;

        img {
          height: 140%;
          margin-right: -50px;
          margin-bottom: -10px;
        }
      }
    }

    .game_list {
      margin-top: 10px;
      display: grid;
      grid-template-columns: 1fr;
      gap: 10px;

      .grid_list {
        .list_img {
          height: 96px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(180deg, #31e2a53d, #ffffff94);

          img {
            width: 54px;
            height: 54px;
            border-radius: 50%;
            display: block;
          }
        }

        .list_cont {
          padding: 12px 14px 14px;

          ._title {
            color: #0f172A;
            font-weight: 600;
          }

          ._subtitle {
            margin-top: 4px;
            color: #7a8597;
          }
        }
      }
    }
  }
}

.close {
  position: absolute;
  top: 5px;
  right: 5px;

  .icon {
    font-size: 20px;
    color: #000;
  }
}

/deep/ .van-overlay {
  display: flex;
  justify-content: flex-end;

  .overlay {
    background-color: #470707;
    border-radius: 10px;
    padding: 10px;
    max-width: 200px;
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .34);
    color: var(--light);
    margin-top: 50px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    gap: calc(11rem / 16);
    margin-right: 10px;

    &_item {
      display: flex;
      align-items: center;
      gap: calc(10rem / 16);

      img {
        width: calc(20rem / 16);
        height: calc(20rem / 16);
        display: block;
      }

      span {
        font-size: calc(12rem / 16);
        color: var(--light);
      }
    }
  }
}
</style>
